export const ItemTypes = {
  PLAYER: 'player',
};

// Friendly names for the engine position codes used in field-positions.json.
export const POSITION_FULL_NAMES = {
  GK: 'Goalkeeper',
  CB: 'Centre Back',
  LB: 'Left Back',
  RB: 'Right Back',
  LWB: 'Left Wing Back',
  RWB: 'Right Wing Back',
  DM: 'Defensive Midfield',
  CM: 'Central Midfield',
  CAM: 'Attacking Midfield',
  LM: 'Left Midfield',
  RM: 'Right Midfield',
  LW: 'Left Wing',
  RW: 'Right Wing',
  LF: 'Left Forward',
  RF: 'Right Forward',
  ST: 'Striker',
};

const MIN_BENCH_SLOT_COUNT = 11;

export const MAX_BENCH_SLOT_COUNT = 11;

export const getBenchSlotCount = (subs = []) => (
  Math.max(MIN_BENCH_SLOT_COUNT, subs.length)
);
